import { render, staticRenderFns } from "./CustomFieldLabelPane.vue?vue&type=template&id=760211bd&"
import script from "./CustomFieldLabelPane.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldLabelPane.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports